import {Component, Inject, Input, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: "edsng-user-projects-actions-dialog",
  templateUrl: "./user-projects-actions-dialog.component.html",
  styleUrls: ["./user-projects-actions-dialog.component.css"]
})
export class UserProjectsActionsDialogComponent implements OnInit {

  @Input() withDelete: boolean = false;
  @Input() withRename: boolean = false;
  @Input() withOpen: boolean = false;
  @Input() withExport: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<UserProjectsActionsDialogComponent>) {
  }

  ngOnInit() {

  }

  close(msg: string) {
    this.dialogRef.close(msg);
  }

}
